import { FC, ReactNode } from 'react';

import styles from './Card.module.scss';

export type CardProps = {
  children?: ReactNode;
  className?: string;
};

export const Card: FC<CardProps> = ({ children, className = '' }) => {
  return <section className={`${styles.card} ${className}`}>{children}</section>;
};
